import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackOpenChatbotClick } from './tracking';
import { openChat } from '../../actions/chatWindow';
import { setMobileActiveSide } from '../../actions/mobileSide';
import { ChatListChatbotItem } from '../../components/ChatListChatbotItem';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { chatbotSelector, chatWindowSelector, openedChatsSelector } from '../../selectors';
import { ETypeChatbot } from '../../types/messages';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { useApplicationContext } from '../../utils/applicationContext';
import { findLastIncomingMessage } from '../../utils/findLastIncomingMessage';

export const ChatListChatbotItemContainer = () => {
  const { config } = useApplicationContext();
  const { currentOpenedChatId } = useSelector(chatWindowSelector);
  const { unreadMessagesCount } = useSelector(chatbotSelector);

  const openedChats = useSelector(openedChatsSelector);

  const dispatch = useDispatch();

  const chatbotChat = openedChats[CHATBOT_ID];

  const isChatbotHelperEnabled = Boolean(config.get<boolean>('frontend-chats.ChatbotHelper.Enabled'));

  const onChatbotClick = React.useCallback(() => {
    trackOpenChatbotClick();
    dispatch(setMobileActiveSide(EMobileLayoutActiveSide.Center));
    dispatch(openChat(CHATBOT_ID));
  }, [dispatch]);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    if (currentOpenedChatId === CHATBOT_ID) {
      queryParams.set('chatbot', '1');
    } else {
      queryParams.delete('chatbot');
    }

    window.history.replaceState(null, '', '?' + queryParams.toString());
  }, [currentOpenedChatId]);

  const { pagesLength, messagesLength, lastMessage } = React.useMemo(() => {
    const { pages = [] } = chatbotChat || {};

    if (!pages.length) {
      return {
        pagesLength: 0,
        messagesLength: 0,
        lastMessage: null,
      };
    }

    const pagesLength = pages.length;
    const pagesLastIndex = pagesLength - 1;
    const { messages } = pages[pagesLastIndex];
    const messagesLength = messages.length;

    const lastMessage = findLastIncomingMessage(chatbotChat, pagesLength - 1, messagesLength - 1);

    return {
      pagesLength,
      messagesLength,
      lastMessage,
    };
  }, [chatbotChat]);

  const message = React.useMemo(() => {
    if (
      (pagesLength === 0 && messagesLength === 0) ||
      !lastMessage ||
      lastMessage.type === ETypeChatbot.TextAndImages
    ) {
      return 'Найду вам недвижимость';
    }

    if (lastMessage.type === ETypeChatbot.Offer) {
      return 'А вот и новая подборка - буду присылать такие, пока вы меня не остановите';
    }

    return lastMessage.message;
  }, [pagesLength, messagesLength, lastMessage]);

  if (!isChatbotHelperEnabled || !chatbotChat) {
    return null;
  }

  return (
    <ChatListChatbotItem
      text={message}
      isActive={currentOpenedChatId === CHATBOT_ID}
      onClick={onChatbotClick}
      unreadCount={unreadMessagesCount}
    />
  );
};
